import  Axios  from "axios";


export const feedsenseApi:any = "https://feedsenseapi.feedsense.ai/";
const authUrl:any = "https://adminapi.feedsense.ai/";
export const graphqlUri:any = "https://feedsenseapi.feedsense.ai/graphql/"
export const liveOverAllAdviceStatus :any = "https://feedsenseapi.feedsense.ai/liveoverall/overall_live_advice_status"
const token:any = ''
const newsUrl:any = ''

export const axios = Axios.create({ baseURL: newsUrl , // News Api
    headers: {bearer: token}});
    
export const axiosAuthService = Axios.create({ baseURL: authUrl , // Auth Api
    headers: {bearer: token}});

export const axiosLocal5000Local = Axios.create({ baseURL: feedsenseApi ,
    headers: {bearer: token}});

export const axiosLocal5000 = Axios.create({ baseURL: feedsenseApi , // Pair Trading Api
    headers: {bearer: token}});  

export const axiosUSD = Axios.create({ baseURL: feedsenseApi , // Buy Sell Api
    headers: {bearer: token}});

export const axiosBuySell = Axios.create({ baseURL: feedsenseApi , // Buy Sell Api
    headers: {bearer: token}});

export const axiosOption = Axios.create({ baseURL: feedsenseApi , // Buy Sell Api
    headers: {bearer: token}});

export const axiosSFMultiday = Axios.create({ baseURL: feedsenseApi, // Stock Future Multiday Api
    headers: {bearer: token}});

export const axiosFXOption = Axios.create({baseURL:feedsenseApi, // fx-option Api
    headers:{bearer:token}})

export const axiosUsdMultiday = Axios.create({ baseURL: feedsenseApi, // Stock Future Multiday Api
    headers: {bearer: token}});

export const axiosESMultiday = Axios.create({ baseURL: feedsenseApi, // Equity Stock Multiday Api
    headers: {bearer: token}});

export const axiosPortfolio = Axios.create({ baseURL: feedsenseApi, // Portfolio Api
    headers: {bearer: token}});